import React, { useState, useEffect } from "react";
import { compose } from "redux";
import classNames from "classnames";

import connectActions from "fantastic/lib/connectActions";
import connectProps from "fantastic/lib/connectProps";
import droppable from "fantastic/components/hoc/droppable";

import favoriteEntity from "fantastic/actions/favoriteEntity";
import Count from "fantastic/components/common/Count";

const Button = ({ onClick, unsaved_count }) => {
  const styles = {
    paddingTop: 15 * unsaved_count,
    paddingBottom: 15 * unsaved_count
  };
  return (
    <a
      className="fantastic-elements-button__link"
      onClick={onClick}
      style={styles}
    >
      <i className="fi fi-newspaper" />
      { i18n.t('elements') }
    </a>
  );
};

const DroppableButton = droppable(["SECTION", "ITEM"])(Button);

const ElementsButton = props => {
  if (!props.enabled) return null;

  const { dragging, unsaved_count, lastAddedEntity, favoriteEntity } = props;
  const elementsButtonClasses = classNames("fantastic-elements-button", {
    "fantastic-elements-button--focus": dragging,
    "fantastic-elements-button--unsaved": unsaved_count > 0
  });
  return (
    <div className={elementsButtonClasses}>
      <DroppableButton {...props} type="CollectionEntity" />
      {lastAddedEntity ? (
        <div className="fantastic-elements-button__saved">
          { i18n.t('element_saved') }
          <a onClick={() => favoriteEntity({ ...lastAddedEntity })}>
            { i18n.t('element_name_desc2') }
          </a>
        </div>
      ) : (
        <div className="fantastic-elements-button__you-can">
          { i18n.t('element_move_to_save') }
        </div>
      )}
    </div>
  );
};

export default compose(
  connectProps({
    dragging: state => state.app.dragging,
    unsaved_count: state =>
      (state.collections.unsaved && state.collections.unsaved.length) || 0,
    lastAddedEntity: state => state.collections.lastAddedEntity,
    enabled: state => state.collections.enabled
  }),
  connectActions({ favoriteEntity })
)(ElementsButton);
